document.addEventListener('DOMContentLoaded', function () {
  // Discover 버튼과 모달 요소 선택
  const discoverBtn = document.getElementById('discoverModalLink');
  const modal = document.getElementById('discoverModal');
  const modalBody = modal.querySelector('.slide-modal-body');
  // close 버튼은 모달 외부에 있으므로 document에서 선택
  const closeModal = document.querySelector('.slide-modal-close');

  // 콘텐츠 캐싱을 위한 Map 객체 생성
  const cache = new Map();

  // Discover 버튼 클릭 이벤트 처리
  discoverBtn.addEventListener('click', function (e) {
    e.preventDefault(); // 링크 기본 동작 차단

    const url = discoverBtn.getAttribute('data-url');

    // 이미 캐싱된 콘텐츠가 있다면 바로 사용
    if (cache.has(url)) {
      modalBody.innerHTML = cache.get(url);
      openModal();
    } else {
      modalBody.innerHTML = 'Loading...';
      openModal();

      // fetch API를 이용해 콘텐츠를 불러옴
      fetch(url)
        .then(response => response.text())
        .then(data => {
          cache.set(url, data);  // 캐싱 처리
          modalBody.innerHTML = data;
        })
        .catch(error => {
          modalBody.innerHTML = 'Error loading content.';
          console.error('Error fetching content:', error);
        });
    }
  });

  // 모달을 열어주는 함수
  function openModal() {
    // 모달이 열릴 때 배경 스크롤 금지
    document.body.style.overflow = 'hidden';
    // 모달을 보이도록 hidden 클래스를 제거
    modal.classList.remove('hidden');
    // 닫기 버튼은 모달 열릴 때 기본적으로 숨김 처리
    closeModal.style.display = 'none';

    // 약간의 딜레이 후 visible 클래스를 추가하여 슬라이드 업 애니메이션 실행
    setTimeout(() => {
      modal.classList.add('visible');
    }, 10);

    // 3초 후에 닫기 버튼 표시
    setTimeout(() => {
      closeModal.style.display = 'block';
    }, 1000);
  }

  // 모달을 닫는 함수
  function closeModalFunction() {
    // 닫기 버튼은 클릭하자마자 바로 숨김
    closeModal.style.display = 'none';

    // visible 클래스를 제거하여 슬라이드 다운 애니메이션 실행
    modal.classList.remove('visible');
    modal.classList.add('hidden-transition');
    setTimeout(() => {
      modal.classList.add('hidden');
      modal.classList.remove('hidden-transition');
      // 모달 닫힌 후 배경 스크롤 복원
      document.body.style.overflow = '';
    }, 600); // transition 지속시간 후 실행
  }

  // 닫기 버튼 클릭 시 모달 닫기
  closeModal.addEventListener('click', closeModalFunction);

  // 모달 배경 영역 클릭 시 닫기 처리
  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeModalFunction();
    }
  });
});
